import React, { Component } from 'react';
import i18n from 'i18n-react';

import { storageKeys } from 'config/settings.json';
import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import SubAppButton from 'components/TrainingGrid/SubAppButton';
import TrainingCard from 'components/TrainingGrid/TrainingCard';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import clsx from 'clsx';

export default class RetainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appId: import.meta.env.VITE_APP_ID,
      email: '',
      lang: '',
      chapters: [],
      chapters_progress: [],
      lockedChapters: [],
      subApps: [],
      subAppsFull: [],
      appName: '',
      featureFlags: [],
    };

    this.loadChapters = this.loadChapters.bind(this);
    this.setSubApps = this.setSubApps.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentDidMount() {
    this.getAppInfo();
  }

  UNSAFE_componentWillMount() {
    this.mounted = true;
    this.getProgress();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async getAppInfo() {
    const { code } = await StorageHandler.load(storageKeys.lang);
    // let lang = `${language}-${language.toUpperCase()}`;

    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      const { appName, featureFlags } = appInfo;
      this.setState({ appName, lang: code, featureFlags });
    }
  }

  getProgress() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        this.setState({ email });
        DataHandler.matchAppId().then((appId) => {
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email)).then((userProgress) => {
            this.calculateProgress(userProgress);
          });
        });
      }
    });
  }

  setSubApps() {
    const { appId, email, lang } = this.state;

    APIHandler.getSubappsNew(appId, email, lang).then(({ categories }) => {
      if (!categories) return;
      const allSubApps = categories
        .map((app) => {
          return app?.micro_modules?.map((app) => {
            return app;
          });
        })
        .flat();
      const fullSub = allSubApps.filter(({ sub_app: subApp }) => {
        return subApp.level === 'iii';
      });

      const microSub = allSubApps.filter(({ sub_app: subApp }) => {
        return subApp.level === 'ii' || subApp.level === 'ii_partner';
      });

      const microTiles = microSub.map((app) => {
        return (
          <SubAppButton
            key={`${app.id}_${app.chapterImage}`}
            progress={app.percentage}
            appId={app.sub_app.id}
            name={app.title}
            pageId={0}
            size={{ height: 50, width: 50 }}
            type="retain"
            backgroundImage={app.image || app.chapterImage}
            level="ii"
            src={app.sub_app.logo_wide_white}
            numChapters={app.count.pages_count}
            uri={app.sub_app.website_url}
            email={email}
            chapterId={app.count.id}
            percentageCompleted={app.percentage}
            locked={app.percentage < 100}
          />
        );
      });
      const fullTiles = fullSub.map((app) => {
        return (
          <SubAppButton
            key={`${app.id}_${app.chapterImage}`}
            progress={app.percentage}
            appId={app.sub_app.id}
            name={app.title}
            pageId={0}
            size={{ height: 50, width: 50 }}
            type="retain"
            backgroundImage={app.background_image || app.image || app.chapterImage}
            level={app.sub_app.level}
            src={app.sub_app.logo_wide_white}
            numChapters={app.count.pages_count}
            uri={app.sub_app.website_url}
            email={email}
            chapterId={app.count.id}
            percentageCompleted={app.percentage}
            locked={app.percentage < 100}
          />
        );
      });

      this.setState({ subAppsFull: fullTiles, subApps: microTiles });
    });
  }

  loadChapters() {
    const { appId, email, lang } = this.state;
    APIHandler.getChaptersAndProgress(appId, email, lang).then(({ chapters }) => {
      const { chapters: allChapters = [] } = chapters?.uncategorized?.[0] ?? {};
      const visibleChapters = allChapters.filter((chapter) => {
        return !(chapter.coming_soon === true && chapter.coming_soon_visible !== true);
      });
      const foundationChapters = visibleChapters.filter((chapter) => {
        return chapter.specialization === 0;
      });
      const specializationChapters = visibleChapters.filter((chapter) => {
        return chapter.specialization === 1;
      });

      const isFoundationalSpan3 = foundationChapters.length % 2 === 0 && foundationChapters.length % 3 !== 0;

      const newChapters = (
        <React.Fragment>
          <span className="subHeader">
            <ContentHeader header={i18n.translate('contentHeaders.maintrainings')} line />
          </span>
          {foundationChapters.map((chapter, key) => {
            return (
              <div
                key={key}
                className={clsx('trainingCard__Animated', {
                  'trainingCard__Animated--span3': isFoundationalSpan3,
                })}
              >
                <TrainingCard
                  chaptersProgress={chapter}
                  chapter={chapter}
                  chapterCount={chapter.chapterItemCount}
                  chapterCountMin={chapter.chapterItemCountMin}
                  index={key}
                  locked={chapter.percentage < 100 || chapter.percentage === undefined}
                  appId={appId}
                  key={chapter.chapterID}
                  redirPath="/main/ret/chapter/"
                  lockedSubtitle={i18n.translate('trainingScreens.unlock', {
                    number: key + 1,
                  })}
                  lockedSubtitleRedirect="/main/training"
                  foundation={true}
                  comingSoon={chapter.coming_soon_visible}
                />
              </div>
            );
          })}
          {specializationChapters.length > 0 && (
            <span className="subHeader">
              <ContentHeader header={i18n.translate('contentHeaders.subtrainings')} line />
            </span>
          )}
          {specializationChapters.map((chapter, key) => {
            return (
              <div
                key={key}
                className={clsx('trainingCard__Animated', {
                  specialization: true,
                })}
              >
                <TrainingCard
                  chaptersProgress={chapter}
                  chapter={chapter}
                  locked={chapter.percentage < 100 || chapter.percentage === undefined}
                  index={key}
                  appId={appId}
                  key={chapter.chapterID}
                  redirPath="/main/ret/chapter/"
                  lockedSubtitle={i18n.translate('trainingScreens.unlock', {
                    number: foundationChapters.length + key + 1,
                  })}
                  lockedSubtitleRedirect="/main/training"
                  foundation={false}
                  comingSoon={chapter.coming_soon_visible}
                />
              </div>
            );
          })}
        </React.Fragment>
      );

      this.setState({
        chapters: newChapters,
      });
    });
  }

  calculateProgress(res) {
    if (res.status !== 'error') {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = (chapter.progress / (chapter.total_pages - 1)) * 100;
          if (newChapter.percentage > 100) {
            newChapter.percentage = 100;
          }
        }
      });
      const visibleChapters = chapters.filter((c) => {
        return !(c.coming_soon === true && c.coming_soon_visible !== true);
      });
      this.setState({ chapters_progress: visibleChapters }, () => {
        this.loadChapters(res.status !== 'error');
        this.setSubApps();
      });
    }
    this.loadChapters(res.status !== 'error');
    this.setSubApps();
  }

  render() {
    const { subApps, chapters, subAppsFull } = this.state;

    return (
      chapters && (
        <div className="wrapper__grid">
          <div className="trainingGrid">{chapters}</div>

          {subApps.length > 0 && (
            <React.Fragment>
              <div className="trainingGrid subApps">
                <span className="subHeader">
                  <ContentHeader header={i18n.translate('contentHeaders.subapps')} line />
                </span>
                {subApps}
              </div>
            </React.Fragment>
          )}
          {subAppsFull.length > 0 && (
            <React.Fragment>
              <div className="trainingGrid subAppsFull">
                <span className="subHeader">
                  <ContentHeader header={i18n.translate('contentHeaders.subAppsFull')} line />
                </span>
                {subAppsFull}
              </div>
            </React.Fragment>
          )}
        </div>
      )
    );
  }
}
